import { useState, useEffect, cloneElement, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import {
  saveSearchOneWay,
  saveSearchRoundTrip,
  saveSearchMultipleDestination,
} from '@shared/redux/actions';
import { createPNRStarlings, postCancelPNR } from '@shared/services/services';
import {
  PAYMENTS_FLIGHTS,
  FLIGHTS_RESERVE_SUCCESSFUL,
  FLIGHTS_SEARCH,
} from '@shared/helpers/routes';

import FlightSteps from './FlightSteps';

export const useContentLogic = children => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const flightsSearchBody = useSelector(store => store.flightsSearchBody);

  const { flightValidate, infoFlightsSearch, isBuy, flightsInUSD } =
    location.state ?? {};

  const isPayment = location.pathname == PAYMENTS_FLIGHTS;

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [cardData, setCardData] = useState();
  const [openModalChangedPNR, setOpenModalChangedPNR] = useState(false);
  const [state, setState] = useState(null);

  const isSubmittingReserveRef = useRef(false);

  useEffect(() => {
    if (flightsSearchBody === null) {
      const actionMap = {
        OneWay: saveSearchOneWay,
        RoundTrip: saveSearchRoundTrip,
        MultipleFlights: saveSearchMultipleDestination,
      };

      const action = actionMap[infoFlightsSearch?.trip_type];
      if (action) {
        dispatch(action(infoFlightsSearch));
      }
    }
  }, [flightsSearchBody, infoFlightsSearch, dispatch]);

  const submitReserve = async (bodyPNR, formReserve) => {
    if (isSubmittingReserveRef.current) return;
    isSubmittingReserveRef.current = true;

    try {
      const res = await createPNRStarlings(bodyPNR);

      setState({ PNR: res, formReserve, ...location.state });

      if (res.prices_changed && res.prices_changed?.total?.diff > 0) {
        setOpenModalChangedPNR(true);
      } else {
        history.push({
          pathname: isBuy ? PAYMENTS_FLIGHTS : FLIGHTS_RESERVE_SUCCESSFUL,
          state: {
            PNR: res,
            formReserve,
            id_user: bodyPNR.id_user,
            ...location.state,
          },
        });
      }
    } catch (err) {
      console.error('error', err);
      setShowModal(true);
    } finally {
      isSubmittingReserveRef.current = false;
    }
  };

  const handleCancel = PNR_code => {
    postCancelPNR({ PNR_code })
      .then(() => history.goBack())
      .catch(err => {
        console.error('error', err);
      });
  };

  const navegateNext = () => {
    setOpenModalChangedPNR(false);
    history.push({
      pathname: isBuy ? PAYMENTS_FLIGHTS : FLIGHTS_RESERVE_SUCCESSFUL,
      state,
    });
  };

  const steps = [
    { title: 'Vuelos', navigate: FLIGHTS_SEARCH, data: { refetch: true } },
    { title: isBuy ? 'Compra' : 'Reserva', navigate: null, data: null },
  ];

  const stepsWrapperComponent = (
    <FlightSteps key={location.pathname} isBuy={isBuy} isPayment={isPayment} />
  );

  const formComponent = cloneElement(children, {
    submitReserve,
    infoFlightsSearch,
    flightsInUSD,
    flightValidate,
    isBuy,
    isLoading,
    setIsLoading,
    cardData,
    setCardData,
  });

  return {
    location,
    history,
    isBuy,
    isPayment,
    showModal,
    setShowModal,
    isLoading,
    setIsLoading,
    cardData,
    setCardData,
    openModalChangedPNR,
    setOpenModalChangedPNR,
    state,
    setState,
    flightValidate,
    infoFlightsSearch,
    flightsInUSD,
    submitReserve,
    handleCancel,
    navegateNext,
    steps,
    stepsWrapperComponent,
    formComponent,
  };
};
